import React from 'react';
import { StyleSheet, View } from 'react-native';
import { COLORS, theme } from '@garnish/constants';

import { webOnlyStyles } from '../../../utils';
import { useStyleSwitch } from '../../../hooks/useStyleSwitch';
import type { ChipBoxProps, ChipState } from '../Chip.types';
import { boxStyles as boxStylesConfig } from '../styles';

// ─────────────────────────────────────────────────────────────────────────────

export const ChipBox = ({ focused, state, children, style }: ChipBoxProps) => {
  const useBoxStyles = useStyleSwitch<ChipState>('state', boxStylesConfig);
  const boxStyles = useBoxStyles(state);

  const chipBoxStyles = [
    styles.box,
    boxStyles,
    chipBoxWebStyles,
    focused ? chipBoxFocusWebStyles : undefined,
    style,
  ];

  return <View style={chipBoxStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  box: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderRadius: theme.radius.xlarge,
    borderColor: COLORS.NEUTRAL_3,
    paddingVertical: theme.spacing['2'],
    paddingHorizontal: theme.spacing['4'],
  },
});

const chipBoxWebStyles = webOnlyStyles({
  outlineWidth: 1,
  outlineOffset: theme.spacing['1'],
  outlineColor: theme.colors.GRAY,
  transition: `background-color ${theme.transitions.base}ms, border-color ${theme.transitions.base}ms`,
});

const chipBoxFocusWebStyles = webOnlyStyles({
  outlineStyle: 'solid',
});
